module.exports = __webpack_public_path__ + "static/media/BONUS_REPORT.080d2b27.svg";